var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-form', { ref: "form", attrs: { "model": _vm.model } }, [_c('el-form-item', { attrs: { "prop": "color" } }, [_c('color-picker', { attrs: { "type": ['single'], "activeType": "single", "currentColor": _vm.currentColor, "disabled-alpha": _vm.disabledAlpha, "no-color-mode": _vm.noColorMode }, on: { "changeColor": function changeColor(val) {
        return _vm.handleColorChange(val);
      } } })], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };